// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.walletconnect.com",
    name: "SampleW",
    homepage: "https://walletconnect.com",
    image_id: "b81aaf2d-3548-4e65-46cd-fd59fbb6b300",
    app: {
        browser: null,
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://cloud.walletconnect.com",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.walletconnect.com",
    mobile: {
        native: null,
        universal: null,
    },
    desktop: {
        native: "sampleW://",
        universal: "https://wallet-connect.sampleW.com",
    },
};
//# sourceMappingURL=index.js.map